'use client';

import { FetchOrderDetailResponseBody } from 'bff';
import { format } from 'date-fns';
import {
  actorName,
  Attribute,
  AttributeLabel,
  AttributeValue,
  OrderItemsTable,
  OrderStatusBadge,
} from 'shared-components';

export const OrderDetail = ({
  data,
}: {
  data: FetchOrderDetailResponseBody;
}) => {
  return (
    <div className='flex flex-col gap-3 bg-white px-2'>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4'>
        {/* <div>
          <p className='text-sm font-semibold'>Estado de la orden</p>
          <OrderStatusBadge status={data.status} />
        </div> */}

        <div className='col-span-full'>
          <Attribute>
            <AttributeLabel>Descripción de la orden</AttributeLabel>
            <AttributeValue>{data.name}</AttributeValue>
          </Attribute>
        </div>

        <Attribute>
          <AttributeLabel>Servicio</AttributeLabel>
          <AttributeValue>{data.service_name}</AttributeValue>
        </Attribute>

        <Attribute>
          <AttributeLabel>Bien</AttributeLabel>
          <AttributeValue>{data.good_name}</AttributeValue>
        </Attribute>

        <Attribute>
          <AttributeLabel>Proveedor asignado</AttributeLabel>
          <AttributeValue>{data.provider.legal_name}</AttributeValue>
        </Attribute>

        <Attribute>
          <AttributeLabel>Localidad o zona del servicio</AttributeLabel>
          <AttributeValue>
            {[data.locality_name, data.department_name, data.province_name]
              .filter(Boolean)
              .join(', ')}
          </AttributeValue>
        </Attribute>

        <Attribute>
          <AttributeLabel>Usuario creación</AttributeLabel>
          <AttributeValue>
            {actorName(data.created_by)}{' '}
            <span className='text-xs text-muted-foreground'>
              ({data.created_by?.email ?? '—'})
            </span>
          </AttributeValue>
        </Attribute>

        <Attribute>
          <AttributeLabel>Fecha creación</AttributeLabel>
          <AttributeValue>
            {format(new Date(data.created_at), 'dd/MM/yyyy HH:mm')}
          </AttributeValue>
        </Attribute>

        <div className='col-span-full'>
          <Attribute>
            <AttributeLabel>Información adicional</AttributeLabel>
            <AttributeValue>
              <span className='text-muted-foreground'>
                {data.description || 'No hay información adicional'}
              </span>
            </AttributeValue>
          </Attribute>
        </div>

        {data.notes && (
          <div className='col-span-full'>
            <Attribute>
              <AttributeLabel>Notas</AttributeLabel>
              <AttributeValue>{data.notes || 'No hay notas'}</AttributeValue>
            </Attribute>
          </div>
        )}

        {/* F2.4 — los archivos de la orden ya no se listan aquí; viven en la
            pestaña Documentación (compañía / proveedor). */}
      </div>

      {/* F2.5 — ítems + cobertura (solo si la orden tiene ítems). */}
      <OrderItemsTable
        items={data.items}
        totalAmount={data.total_amount}
        coverageAmount={data.coverage_amount}
        amountToCharge={data.amount_to_charge}
        taxesPercent={data.taxes_percent}
        taxesAmount={data.taxes_amount}
        totalWithTaxes={data.total_with_taxes}
        currency={data.currency}
      />
    </div>
  );
};
